// extracted by mini-css-extract-plugin
export default {"chatPageChat2":"Chat2_chatPageChat2__jsUEJ"};